/* eslint-disable guard-for-in */
// noinspection GraphQLSchemaValidation

import { FILTER_SKELETON } from '@plugins/vehiclefleetapp';
import { gql } from '@apollo/client';

export const queryVariables = [];
export const queryArguments = [];
export const queryFields = [];

// eslint-disable-next-line no-restricted-syntax
for (const key in FILTER_SKELETON) {
  queryVariables.push(`$${key}: ${FILTER_SKELETON[key].type}`);
  queryArguments.push(`${key}: $${key}`);
  queryFields.push(key);

  if (FILTER_SKELETON[key].hasValues) {
    queryFields.push(FILTER_SKELETON[key].valuesSchema ?? FILTER_SKELETON[key].hasValues);
  }
}

export const QUERY_CAR_SEARCH_FILTER_DATA = gql`
  query GetSearchFilterData(${queryVariables.join(', ')}) {
    carSearchFilterData(${queryArguments.join(', ')}) {
      ${queryFields.join('\n')}
    }
    carSearchResultCount(${queryArguments.join(', ')}) {
      totalCount
    }
  }
`;
